import { jsx as _jsx } from "preact/jsx-runtime";
import CameraIcon from './CameraIcon.js';
export default function SnapshotButton({ onSnapshot, i18n, }) {
    return (_jsx("button", { className: "uppy-u-reset uppy-c-btn uppy-Webcam-button uppy-Webcam-button--picture", type: "button", title: i18n('takePicture'), "aria-label": i18n('takePicture'), onClick: onSnapshot, "data-uppy-super-focusable": true, children: CameraIcon() }));
}
